const transactionActionTypes = {
    FETCH_TRANSACTIONS_START: 'FETCH_TRANSACTIONS_START',
    FETCH_TRANSACTIONS_SUCCESS: 'FETCH_TRANSACTIONS_SUCCESS',
    FETCH_TRANSACTIONS_FAILURE: 'FETCH_TRANSACTIONS_FAILURE'
};

export default transactionActionTypes;
